export const collectIdAndData = doc => ({id: doc.id, ...doc.data()});